import React from 'react';
import { Shield } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="bg-white py-[100px] px-5" data-id="element-234">
      <div className="max-w-[640px] mx-auto" data-id="element-235">
        <div className="border-[2px] border-success-green rounded-2xl p-[40px] md:p-[52px_48px] bg-white text-center relative" data-id="element-236">
          <div className="flex justify-center mb-6" data-id="element-237">
            <div className="bg-success-green/10 p-4 rounded-full" data-id="element-238">
              <Shield className="w-12 h-12 text-success-green" data-id="element-239" />
            </div>
          </div>

          <h2 className="font-serif text-[28px] md:text-[32px] text-primary-dark mb-8" data-id="element-240">
            The 'Chapter 5' Guarantee
          </h2>

          <div className="font-sans text-[18px] text-primary-dark/80 leading-[2] mb-8" data-id="element-241">
            <p className="mb-4" data-id="element-242">Here's my promise — in writing:</p>
            <p className="mb-4" data-id="element-243">
              Read Chapter 5.
              <br data-id="element-244" />
              Use one script.
              <br data-id="element-245" />
              Make one phone call.
            </p>
            <p className="font-bold text-primary-dark mb-4" data-id="element-246">
              If you don't save more than $9.99 on your first call —<br data-id="element-247" />I will
              refund every single penny.
            </p>
            <p data-id="element-248">
              No forms. No explanation required.
              <br data-id="element-249" />
              One email. 24-hour refund.
            </p>
          </div>

          <div className="w-16 h-px bg-success-green/30 mx-auto mb-8" data-id="element-250"></div>

          <div className="font-sans text-[18px] text-primary-dark/80 leading-[2] mb-8" data-id="element-251">
            <p className="mb-4" data-id="element-252">Why am I this confident?</p>
            <p className="mb-4" data-id="element-253">
              Because I was in a hospital bed with $40,000 in debt and I built
              these tools because I NEEDED them to work.
            </p>
            <p data-id="element-254">
              Not to impress anyone. Not to sell a book.
              <br data-id="element-255" />
              To actually work.
              <br data-id="element-256" />
              And they do.
            </p>
          </div>

          <div className="bg-success-green/5 rounded-lg p-6 mt-8 mb-10" data-id="element-257">
            <p className="font-sans font-bold text-[20px] text-primary-dark mb-2" data-id="element-258">
              You literally cannot lose money on this book.
            </p>
            <p className="font-sans text-[15px] text-primary-dark/60" data-id="element-259">
              Worst case: $9.99 refunded.
              <br data-id="element-260" />
              Best case: Your Sunday nights, back.
            </p>
          </div>

          <CTAButton subText="Chapter 5 money-back guarantee · Zero risk" data-id="element-261">
            RISK-FREE — GET THE SYSTEM → $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}